import {
  createColumn,
  formatAmount,
  formatDateTime,
} from "../../utils/helpers";
import { TFieldConfig } from "../../types/common";
import { API_ADVANCES_BALANCE } from "../../utils/apis";
import { Tag } from "antd";

interface UseVehicleLedgerAdvanceProps {
  form: any;
  updateFormValue: (field: string, value: any) => void;
  updateFormValues: (values: any) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  filters: any;
  setFilters: (filters: any) => void;
  setError: (error: any) => void;
}

export const useVehicleLedgerAdvance = ({}: UseVehicleLedgerAdvanceProps) => {
  const searchFields: TFieldConfig[] = [
    {
      field_name: "phone_number",
      label: "Phone Number",
      type: "tel",
      props: {
        placeholder: "Enter phone number",
        required: true,
      },
    },

    {
      field_name: "start_date",
      label: "Start Date",
      type: "date",
      props: {
        placeholder: "DD/MM/YYYY",
        format: "DD/MM/YYYY",
      },
    },
    {
      field_name: "end_date",
      label: "End Date",
      type: "date",
      props: {
        placeholder: "DD/MM/YYYY",
        format: "DD/MM/YYYY",
      },
    },
  ];

  const tableColumns = () => [
    createColumn("car_numbers", false, "Linked Cars"),
    createColumn("balance", false, "Balance"),
    createColumn("created_at", false, "Created At"),
    createColumn("created_by", false, "Created By"),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data?.map((item: any) => {
      return {
        ...item,
        car_numbers:
          item?.car_numbers?.map((car_number: string) => (
            <Tag key={car_number} color="blue">
              {car_number}
            </Tag>
          )) || "N/A",
        balance: item.balance ? formatAmount(item.balance) : "N/A",
        created_at: formatDateTime(item.created_at) || "N/A",
        created_by:
          item.created_by?.first_name + " " + item.created_by?.last_name ||
          "N/A",
      };
    });
  };

  const api = API_ADVANCES_BALANCE;
  const tableTitle = "Advanced Search Results";
  const initialFilters = { booking_type: "advance", status: "confirmed" };
  // const exportData = {
  //   api: `${API_ADVANCES_BALANCE}/export/`,
  //   fileName: "vehicle_ledger_advance.xlsx",
  // };

  return {
    searchFields,
    tableColumns,
    tableData,
    tableTitle,
    api,
    initialFilters,
    // exportData,
  };
};
